// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__zByqY","small":"Button_small__I6X0A","inlineBlock":"Button_inlineBlock__lK+XI","disabled":"Button_disabled__0KUIl","secondary":"Button_secondary__z2bYv"};